import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';
import React, { useState } from 'react';
import { type DataTableRowEventHandler, ErpDataTableV2 } from '@/components/custom/erp/data-table-v2';
import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from '@/components/ui/dialog';
import { AritoFormV2, BottomActionBarV2, AritoIcon } from '@/components/custom/erp';
import { initialValues, type SearchFormValues, searchSchema } from './schemas';
import BasicInfoTab from './components/tabs/BasicInfoTab';
import { useDialogStack } from '@/hooks/use-dialog-stack';
import { exportMainColumns } from './cols-definition';
import DetailTab from './components/tabs/DetailTab';
import { ActionBar } from './components/Actionbar';
import OtherTab from './components/tabs/OtherTab';

const TatToanHoaDonPage = ({ initialRows }: { initialRows: MuaHangRecord[] }) => {
  const [showSearchForm, setShowSearchForm] = useState(true);
  const [hasSearchedOnce, setHasSearchedOnce] = useState(false);
  const [formMode, setFormMode] = useState<'add' | 'edit' | 'view'>('add');
  const [currentObj, setCurrentObj] = useState<MuaHangRecord | null>(null);
  const [selectedObj, setSelectedObj] = useState<MuaHangRecord | null>(null);
  const [mainRows, setMainRows] = useState<MuaHangRecord[]>(initialRows);
  const { contentZIndex, overlayZIndex } = useDialogStack(showSearchForm);

  const handleOpenEditForm = (obj: MuaHangRecord) => {
    setFormMode('edit');
    setCurrentObj(obj);
    setShowSearchForm(true);
  };

  const handleOpenViewForm = (obj: MuaHangRecord) => {
    setFormMode('view');
    setCurrentObj(obj);
    setShowSearchForm(true);
  };

  const handleCreate = () => {
    setFormMode('add');
    setCurrentObj(null);
    setShowSearchForm(true);
  };

  const handleRefresh = () => {};

  const handlePinColumn = () => {};

  const handleSubmit = (data: SearchFormValues) => {
    console.log('Search data:', data);
    setShowSearchForm(false);
    setHasSearchedOnce(true);
  };

  const handleRowClick: DataTableRowEventHandler = params => {
    setSelectedObj(params.row);
  };

  const tables = [
    {
      name: 'Tất cả',
      rows: mainRows.filter(row => row.disabled === '1'),
      columns: exportMainColumns(),
      tabProps: { className: 'whitespace-nowrap' }
    }
  ];

  return (
    <div className='flex h-full min-h-screen flex-col'>
      {hasSearchedOnce && (
        <div className='relative z-0'>
          <ActionBar
            onSearch={() => setShowSearchForm(true)}
            onRefresh={handleRefresh}
            onPinColumns={handlePinColumn}
            isEditDisabled={!selectedObj}
          />
          <div className='flex-1'>
            <ErpDataTableV2
              data-perf-id='mua-hang-tat-toan-hoa-don-master-table'
              tables={tables}
              selectedRowId={selectedObj?.uuid || selectedObj?.id}
              onRowClick={handleRowClick}
            />
          </div>
        </div>
      )}

      <Dialog
        modal={true}
        open={showSearchForm}
        onOpenChange={() => {
          setShowSearchForm(false);
          setHasSearchedOnce(true);
        }}
      >
        <DialogPortal>
          <DialogOverlay className='fixed inset-0 bg-black/50' style={{ zIndex: overlayZIndex }} />
          <div className='fixed inset-0 flex items-center justify-center p-4' style={{ zIndex: contentZIndex }}>
            <DialogPrimitive.Content
              onOpenAutoFocus={event => event.preventDefault()}
              onCloseAutoFocus={event => event.preventDefault()}
              onInteractOutside={event => event.preventDefault()}
              onPointerDownOutside={event => event.preventDefault()}
              onFocusOutside={event => event.preventDefault()}
              className='flex max-h-[85vh] w-[920px] flex-col overflow-hidden border border-[#cfd8e3] bg-white shadow-lg outline-none'
            >
              <div className='flex h-11 min-h-11 items-center justify-between border-b border-[#d1d5db] bg-[#f2f7fc] pl-3.5 pr-4'>
                <DialogTitle className='flex items-center text-[16px] font-bold text-black'>
                  <AritoIcon icon={699} className='mx-2' />
                  <span>Tất toán hoá đơn</span>
                </DialogTitle>
                <button
                  type='button'
                  onClick={() => {
                    setShowSearchForm(false);
                    setHasSearchedOnce(true);
                  }}
                  className='inline-flex size-8 items-center justify-center'
                >
                  <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-[18px]' />
                </button>
              </div>
              <AritoFormV2<SearchFormValues>
                mode={formMode}
                schema={searchSchema}
                initialData={currentObj || initialValues}
                hasAritoActionBar={false}
                className='!static !w-full'
                onSubmit={handleSubmit}
                onClose={() => {
                  setShowSearchForm(false);
                  setHasSearchedOnce(true);
                }}
                headerFields={
                  <div className='max-h-[calc(100vh-250px)] w-[900px] min-w-[900px] overflow-y-auto'>
                    <BasicInfoTab formMode={formMode} />
                  </div>
                }
                tabs={[
                  {
                    id: 'chi-tiet',
                    label: 'Chi tiết',
                    component: <DetailTab formMode={formMode} />
                  },
                  {
                    id: 'khac',
                    label: 'Khác',
                    component: <OtherTab formMode={formMode} />
                  }
                ]}
                bottomBar={
                  <BottomActionBarV2
                    mode={formMode === 'view' ? 'view' : 'search'}
                    onClose={() => {
                      setShowSearchForm(false);
                      setHasSearchedOnce(true);
                    }}
                    submitTitle='Đồng ý'
                  />
                }
              />
            </DialogPrimitive.Content>
          </div>
        </DialogPortal>
      </Dialog>
    </div>
  );
};

export default TatToanHoaDonPage;
